import { SettingsService } from '../../views/pages/configuration/settings/settings.service';
import { lastValueFrom } from 'rxjs';

// Store a reference to the service instance
let settingsServiceInstance: SettingsService | null = null;

/**
 * Sets the settings service instance for this file
 */
export function setSettingsServiceInstance(service: SettingsService): void {
  settingsServiceInstance = service;
}

/**
 * Conditionally loads the alert module based on the displayAlertsV2 flag
 */
export const loadAlertModule = () => {
  if (!settingsServiceInstance) {
    // Fallback to new module if service is not available
    return import('../../views/pages/alert-v2/alert-v2.module').then(m => m.AlertV2Module);
  }

  return lastValueFrom(settingsServiceInstance.getPageSettings('alertsPage')).then((pageSettings: any) => {
    const settings = pageSettings?.settings ?? [];
    const displayAlertsV2Setting = settings.find((setting: any) => setting.fieldKey === 'displayAlertsV2');
    const useV2 = displayAlertsV2Setting?.value === true;
    settingsServiceInstance.setShowAlertV2Flag(useV2);

    if (useV2) {
      return import('../../views/pages/alert-v2/alert-v2.module').then(m => m.AlertV2Module);
    } else {
      return import('../../views/pages/alert/alert.module').then(m => m.AlertModule);
    }
  }).catch((error) => {
    // Fallback to new module on error
    return import('../../views/pages/alert-v2/alert-v2.module').then(m => m.AlertV2Module);
  });
};
